import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const summaryContent: SxStyle = {
  width: '100%',
};

export const title: SxStyle = {
  fontSize: (p) => p.typography.body2.fontSize,
};

export const count: SxStyle = {
  display: 'flex',
  fontSize: (p) => p.typography.body2.fontSize,
  color: (p) => p.palette.primary[300],
};
export const clear: SxStyle = {
  fontSize: '10px',
  color: (p) => p.palette.grey[500],
};

export const typeIcon: SxStyleFunc<boolean> = (isCompany) => ({
  color: isCompany
    ? (p) => p.palette.primary[500]
    : (p) => p.palette.success[700],
});
